import { InteractContract } from '@terra/shared-contracts-interact';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'attacker';

export const interactClient = createTerraOrpcClient({
  contract: InteractContract,
  serviceName: SERVICE_NAME,
});
